import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import { ButtonContainer } from "./GeneralParameterAction.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import "../../GeneralParametersList.scss";
import AddEditGeneralParameter from "../../../AddEditGeneralParameter";
import {
  deleteCountryParameter,
  updateCountryParameter,
} from "../../GeneralParametersList.api";

// Rule 6: Edit icon (always shown) + Disable/Enable icon depending on status.
const GeneralParameterAction = (props) => {
  const { t, data, updateRefeshStatus, countries } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isEditPopupVisible, setEditPopupVisible] = useState(false);

  const handleToggleStatus = () => {
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (!isConfirm) return;

    const request = data.isActive
      ? deleteCountryParameter(data.id)
      : updateCountryParameter(data.id, {
          id: data.id,
          code: data.code,
          description: data.description,
          value: data.value,
          isActive: 1,
          country: data.country?.id ? { id: data.country.id } : null,
        });

    request
      .then(() => {
        updateRefeshStatus();
      })
      .catch((error) => handleApiError(error))
      .finally(() => setActionConfirmStatus(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editParameter = () => setEditPopupVisible(true);
  const closeEditPopup = () => setEditPopupVisible(false);

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={editParameter}
          title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          className="general-parameters-list__action-icon"
        />
        {data.isActive ? (
          <Image
            src={deleteIcon}
            onClick={handleToggleStatus}
            alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            className="general-parameters-list__action-icon"
          />
        ) : (
          <Image
            src={activateIcon}
            onClick={handleToggleStatus}
            alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            className="general-parameters-list__action-icon"
          />
        )}
      </div>

      {isEditPopupVisible && (
        <AddEditGeneralParameter
          onClose={closeEditPopup}
          updateRefeshStatus={updateRefeshStatus}
          selectedParam={data}
          isEditMode
          id={data.id}
        />
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={
            data.isActive
              ? t("GENERIC_CONFIRMATION_BOX_DISABLE")
              : t("GENERIC_CONFIRMATION_BOX_ENABLE")
          }
          message={
            data.isActive
              ? t("GENERIC_CONFIRMATION_BOX_DISABLE_CONTENT")
              : t("GENERIC_CONFIRMATION_BOX_ENABLE_CONTENT")
          }
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

GeneralParameterAction.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    code: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.string,
    isActive: PropTypes.bool,
    country: PropTypes.object,
  }).isRequired,
  updateRefeshStatus: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object),
};

GeneralParameterAction.defaultProps = {
  countries: [],
};

export default withTranslation()(GeneralParameterAction);
